import React from 'react';
import { Button } from 'reactstrap';

const TemplateStatus = ({
  status,
  validateTemplate,
  rejectTemplate,
}) => (
  <div style={styles.row}>
    <p style={styles.status(status)}>
      Status:
      {' '}
      {status || 'PENDING'}
    </p>
    {(status !== 'ACCEPTED') && (
      <Button
        type="button"
        color="success"
        onClick={validateTemplate}
        style={styles.moderateButton}
      >
        Publish Now
      </Button>
    )}
    {(status !== 'REJECTED') && (
      <Button
        type="button"
        color="danger"
        onClick={rejectTemplate}
      >
        Reject
      </Button>
    )}
  </div>
);

const styles = {
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },
  moderateButton: {
    marginRight: 10,
  },
  status: (status) => {
    let color = 'black';
    if (status === 'ACCEPTED') color = 'green';
    if (status === 'REJECTED') color = 'red';
    return {
      color,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: 'unset',
      marginRight: 10,
    };
  },
};

export default TemplateStatus;



// WEBPACK FOOTER //
// ./src/components/templates-manager/template-components/TemplateStatus.js